import styled from "styled-components";

const ViewProductSectionHeader = styled.h2`
  font-size: 1rem;
  color: var(--color-gray-800);
  line-height: 1.2rem;
`;

export default ViewProductSectionHeader;
